export const robots = [
    {
        id:1,
        name:'Orlando Barrera Perez',
        username: 'Orlando',
        email:'ojbarrer@uwaterloo.ca'
    },
    {
        id: 5,
        name: 'James Constable',
        username: 'james',
        email: 'james@gmail.com'
    },
    {
        id:3,
        name:'Shirley Constable',
        username: 'shirley',
        email:'shirley@gmail.com'
    },
    {
        id:2,
        name:'Anne Constable',
        username: 'anne',
        email:'anne@gmail.com'
    },
    {
        id:4,
        name:'Grace Constable',
        username: 'grace',
        email:'grace@gmail.com'
    },
    {
        id: 6,
        name: 'Mrs. Dennis Schulist',
        username: 'Leopoldo_Corkery',
        email: 'Karley_Dach@jasper.info'
    },
    {
        id: 7,
        name: 'Kurtis Weissnat',
        username: 'Elwyn.Skiles',
        email: 'Telly.Hoeger@billy.biz'
    },
    {
        id: 8,
        name: 'Nicholas Runolfsdottir V',
        username: 'Maxime_Nienow',
        email: 'Sherwood@rosamond.me'
    },
    {
        id: 9,
        name: 'Glenna Reichert',
        username: 'Delphine',
        email: 'Chaim_McDermott@dana.io'
    },
    {
        id: 10,
        name: 'Clementina DuBuque',
        username: 'Moriah.Stanton',
        email: 'Rey.Padberg@karina.biz'
    }
];